var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIconFalse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.203 6.205l-.974.82c1.734 1.295 3.35 2.78 4.77 4.265-2.175 2.191-3.88 4.348-4.776 5.215l1.853 1.55c.66-1.36 2.09-3.421 4.01-5.583 1.918 2.174 3.355 4.247 4.015 5.613 0 0 1.805-1.919 1.966-1.622-.695-.784-2.394-3.065-4.675-5.4 1.307-1.341 2.774-2.672 4.342-3.842l-.428-.796c-1.776.885-3.468 2.198-4.989 3.593C10.784 8.563 9.05 7.18 7.203 6.205z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/product_icon_false.f69cad88.svg";
export { SvgProductIconFalse as ReactComponent };